{
  "remove": "Fjern"
}
